import merge from 'lodash/merge';
import { StyleSheet } from 'react-native';
import gradientViewConfig from '../../../../constants/theme-config/gradientViewConfig';
import { fitContentWidth } from '../../../../utils';
import { getTypographyStyles } from '../../TypographyStyles';
export var marginBottom = {
  android: {
    h6: 7,
    h5: 8,
    h4: 9,
    h3: 10,
    h2: 12,
    h1: 13,
    'h6-bold': 7,
    'h5-bold': 8,
    'h4-bold': 9,
    'h3-bold': 10,
    'h2-bold': 12,
    'h1-bold': 13,
    'body-para-xxxs': 2,
    'body-para-xxs': 3,
    'body-para-xs': 3.5,
    'body-para-sm': 4,
    'body-para-md': 4.5,
    'body-para-lg': 5,
    'body-para-xl': 5.5,
    'body-para-xxxs-bold': 2,
    'body-para-xxs-bold': 3,
    'body-para-xs-bold': 3.5,
    'body-para-sm-bold': 4,
    'body-para-md-bold': 4.5,
    'body-para-lg-bold': 5,
    'body-para-xl-bold': 5.5,
    'body-single-line-xxxs': 2,
    'body-single-line-xxs': 3,
    'body-single-line-xs': 3,
    'body-single-line-sm': 4,
    'body-single-line-md': 4.5,
    'body-single-line-lg': 5,
    'body-single-line-xl': 6,
    'body-single-line-xxxs-bold': 2,
    'body-single-line-xxs-bold': 3,
    'body-single-line-xs-bold': 3,
    'body-single-line-sm-bold': 4,
    'body-single-line-md-bold': 4.5,
    'body-single-line-lg-bold': 5,
    'body-single-line-xl-bold': 6,
    'title-para-sm': 3,
    'title-para-md': 3.2,
    'title-para-lg': 4,
    'title-para-sm-bold': 3,
    'title-para-md-bold': 3.2,
    'title-para-lg-bold': 4,
    'title-single-line-sm': 3,
    'title-single-line-md': 3,
    'title-single-line-lg': 4,
    'title-single-line-xl': 4.5,
    'body-hyperlink-xxxs': 4,
    'body-hyperlink-xxs': 3,
    'body-hyperlink-xs': 3.5,
    'body-hyperlink-sm': 4,
    'body-hyperlink-md': 4.5,
    'body-hyperlink-lg': 5,
    'body-hyperlink-xl': 5.5,
    'body-hyperlink-xxxs-bold': 4,
    'body-hyperlink-xxs-bold': 3,
    'body-hyperlink-xs-bold': 3.5,
    'body-hyperlink-sm-bold': 4,
    'body-hyperlink-md-bold': 4.5,
    'body-hyperlink-lg-bold': 5,
    'body-hyperlink-xl-bold': 5.5,
    'button-text-primary-sm': 4,
    'button-text-primary-md': 4,
    'button-text-primary-lg': 5,
    'button-text-secondary-sm': 4,
    'button-text-secondary-md': 4,
    'button-text-secondary-lg': 5,
    'button-text-tertiary-sm': 4,
    'button-text-tertiary-md': 4,
    'button-text-tertiary-lg': 5,
    'button-text-alternate-sm': 4,
    'button-text-alternate-md': 4,
    'button-text-alternate-lg': 5,
    'button-text-alternate-light-sm': 4,
    'button-text-alternate-light-md': 4,
    'button-text-alternate-light-lg': 5,
    'button-text-alternate-dark-sm': 4,
    'button-text-alternate-dark-md': 4,
    'button-text-alternate-dark-lg': 5
  },
  ios: {
    h6: 2.5,
    h5: 2,
    h4: 1.5,
    h3: 1,
    h2: 1,
    h1: 1,
    'h6-bold': 2.5,
    'h5-bold': 2,
    'h4-bold': 1.5,
    'h3-bold': 1,
    'h2-bold': 1,
    'h1-bold': 1,
    'body-para-xxxs': 3,
    'body-para-xxs': 3,
    'body-para-xs': 1,
    'body-para-sm': 1,
    'body-para-md': 0.8,
    'body-para-lg': 0.8,
    'body-para-xl': 0.5,
    'body-para-xxxs-bold': 3,
    'body-para-xxs-bold': 3,
    'body-para-xs-bold': 1,
    'body-para-sm-bold': 1,
    'body-para-md-bold': 0.8,
    'body-para-lg-bold': 0.8,
    'body-para-xl-bold': 0.5,
    'body-single-line-xxxs': 3,
    'body-single-line-xxs': 3,
    'body-single-line-xs': 3,
    'body-single-line-sm': 3,
    'body-single-line-md': 3,
    'body-single-line-lg': 2.5,
    'body-single-line-xl': 2.5,
    'body-single-line-xxxs-bold': 3,
    'body-single-line-xxs-bold': 3,
    'body-single-line-xs-bold': 3,
    'body-single-line-sm-bold': 3,
    'body-single-line-md-bold': 3,
    'body-single-line-lg-bold': 2.5,
    'body-single-line-xl-bold': 2.5,
    'body-hyperlink-xxxs': 3,
    'body-hyperlink-xxs': 3,
    'body-hyperlink-xs': 3,
    'body-hyperlink-sm': 3,
    'body-hyperlink-md': 3,
    'body-hyperlink-lg': 3,
    'body-hyperlink-xl': 3,
    'title-para-sm': 3,
    'title-para-md': 1,
    'title-para-lg': 1,
    'title-para-sm-bold': 3,
    'title-para-md-bold': 1,
    'title-para-lg-bold': 1,
    'title-single-line-sm': 3,
    'title-single-line-md': 2,
    'title-single-line-lg': 3,
    'title-single-line-xl': 3,
    'button-text-primary-sm': 3,
    'button-text-primary-md': 3,
    'button-text-primary-lg': 3,
    'button-text-secondary-sm': 3,
    'button-text-secondary-md': 3,
    'button-text-secondary-lg': 3,
    'button-text-tertiary-sm': 3,
    'button-text-tertiary-md': 3,
    'button-text-tertiary-lg': 3,
    'button-text-alternate-sm': 3,
    'button-text-alternate-md': 3,
    'button-text-alternate-lg': 3,
    'button-text-alternate-light-sm': 3,
    'button-text-alternate-light-md': 3,
    'button-text-alternate-light-lg': 3,
    'button-text-alternate-dark-sm': 3,
    'button-text-alternate-dark-md': 3,
    'button-text-alternate-dark-lg': 3
  }
};
export var getGradientTextStyles = props => {
  var _a;
  var typographyStyles = getTypographyStyles(props);
  var styles = Object.assign({}, typographyStyles.typography);
  styles === null || styles === void 0 ? true : delete styles.whiteSpace;
  styles === null || styles === void 0 ? true : delete styles.textTransform;
  return {
    styles,
    isUpperCase: ((_a = typographyStyles === null || typographyStyles === void 0 ? void 0 : typographyStyles.typography) === null || _a === void 0 ? void 0 : _a.textTransform) === 'uppercase'
  };
};
export var getGradientViewConfigData = props => {
  var _a;
  var gradientConfigData = (_a = props === null || props === void 0 ? void 0 : props.config) === null || _a === void 0 ? void 0 : _a[props === null || props === void 0 ? void 0 : props.type];
  return gradientConfigData;
};
export var getGradientViewStyles = props => {
  var _a, _b;
  var hasGradientText = (_a = props === null || props === void 0 ? void 0 : props.typographyProps) === null || _a === void 0 ? void 0 : _a.text;
  var hasTextAlignment = (_b = props === null || props === void 0 ? void 0 : props.typographyProps) === null || _b === void 0 ? void 0 : _b.textAlignment;
  return StyleSheet.create({
    container: Object.assign(Object.assign({
      position: 'relative'
    }, !hasGradientText && {
      overflow: 'hidden'
    }), !hasTextAlignment && fitContentWidth())
  });
};
export var getGradientViewProps = (props, context) => {
  var _a;
  var theme = (props === null || props === void 0 ? void 0 : props.theme) || (context === null || context === void 0 ? void 0 : context.theme);
  var configProps = merge(gradientViewConfig === null || gradientViewConfig === void 0 ? void 0 : gradientViewConfig[theme], (_a = context === null || context === void 0 ? void 0 : context.gradientView) === null || _a === void 0 ? void 0 : _a[theme]);
  return Object.assign(Object.assign({
    theme
  }, configProps), props);
};